import axios from 'axios'
import { baseURL } from '../utils/baseURL.js'

export function request(config) {
  const instance = axios.create({
    // baseURL: 'https://dpinterface.djplus.cn', //正式服地址
    baseURL: baseURL,
    // baseURL:'http://demo1.djplus.com.cn', //迭代测试服地址
    timeout: 5000
  })

  instance.interceptors.request.use(config => {
    return config
  }, err => {
    console.log(err)
  })

  instance.interceptors.response.use(res => {
    return res.data
  }, err => {
    console.log(err)
  })

  return instance(config)
}